import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './Divider.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const cln = classnames.bind(styles);

/** This component works as html `<hr/>` tag but contains predefined styles and a helper 'margin' prop for easier positioning. All other props are passed through to the `<hr />` tag */
function Divider({
  margin,
  className,
  style,
  ...rest
}) {
  return /*#__PURE__*/_jsx("hr", {
    className: cln('Divider', className),
    style: {
      ...(margin && {
        margin
      }),
      ...style
    },
    ...rest
  });
}
Divider.propTypes = {
  /** margin in CSS format */
  margin: PropTypes.string,
  /** @ignore */
  style: PropTypes.object,
  /** @ignore */
  className: PropTypes.string
};
export default Divider;